// Configuração centralizada para HERE Maps API

// Pool de chaves da API para distribuir carga
const API_KEYS = [
  // DESATIVADA: esta chave retorna 403 Forbidden no serviço de Vector Tiles
  // (cota excedida / serviço não habilitado na conta HERE). Era a causa do
  // mapa abrir em branco de forma intermitente, já que a rotação alternava
  // entre uma chave boa e esta quebrada. Reative só após confirmar no painel
  // da HERE que voltou a ter acesso ao Vector Tile API.
  // '4irBHq1OWqkGdqqToKd8gO3ObihhoabnTU8RFi06rhY',
  'Iz6HmBt3MlkMApZv1l8NYVtWHZNvdDViU84j4i-0xQI',
  // Adicione mais chaves aqui quando criar novas contas
  // 'chave2_aqui',
  // 'chave3_aqui',
  // 'chave4_aqui',
  // 'chave5_aqui'
];

// Índice para rotação sequencial
let currentKeyIndex = 0;

// Rotação aleatória de chaves
export function getRandomApiKey() {
  const index = Math.floor(Math.random() * API_KEYS.length);
  console.log(`Usando API key índice: ${index}`);
  return API_KEYS[index];
}

// Rotação sequencial (distribui melhor a carga)
export function getNextApiKey() {
  const key = API_KEYS[currentKeyIndex];
  console.log(`Usando API key índice: ${currentKeyIndex}`);
  currentKeyIndex = (currentKeyIndex + 1) % API_KEYS.length;
  return key;
}

// Rotação baseada em hash do cliente (sempre mesma chave pro mesmo cliente)
export function getApiKeyForClient(clientId) {
  if (!clientId) return getNextApiKey();

  const hash = clientId.split('').reduce((acc, char) =>
    acc + char.charCodeAt(0), 0
  );
  const index = hash % API_KEYS.length;
  console.log(`Cliente ${clientId} usando API key índice: ${index}`);
  return API_KEYS[index];
}

// Configurações de performance
export const MAP_CONFIG = {
  // Intervalo de atualização em milissegundos
  UPDATE_INTERVAL: 15000,

  // Intervalo de atualização em horário de pico (11h-14h e 18h-22h)
  PEAK_UPDATE_INTERVAL: 20000,

  // Timeout para carregar tiles
  TILE_LOAD_TIMEOUT: 60000,

  // Configurações de cache
  ENABLE_CACHE: true,

  // Limite de marcadores visíveis simultaneamente
  MAX_MARKERS: 100
};

// Detecta se está em horário de pico
export function isPeakTime() {
  const hour = new Date().getHours();
  return (hour >= 11 && hour <= 14) || (hour >= 18 && hour <= 22);
}

// Retorna intervalo de atualização baseado no horário
export function getUpdateInterval() {
  return isPeakTime()
    ? MAP_CONFIG.PEAK_UPDATE_INTERVAL
    : MAP_CONFIG.UPDATE_INTERVAL;
}

// Exporta a chave padrão para compatibilidade
export const DEFAULT_API_KEY = API_KEYS[0];